import * as React from "react";
import PublicLayout from "../Layouts/Public";
import TitleAndInfo from "../TitleAndInfo";
import languages from "../../language/languages";
import { LockOutlined, NumberOutlined } from '@ant-design/icons';
import { Form } from '@ant-design/compatible';
import '@ant-design/compatible/assets/index.css';
import { Button } from "antd";
import {Field, reduxForm} from "redux-form";
import {CreatePasswordField, CreateTextField} from "../../helpers/InputCreator";
import {required, requireden} from "../../helpers/validations";
import {connect} from "react-redux";
import login from "../../actions/login";
import {push} from "connected-react-router";
import generateP12 from "../../actions/generateP12";
import {SHOW_MSG} from "../../types";
import {MAIN_ROUTE} from "../Main/routes";

class GenerateCertP12 extends React.Component
{
    generateP12 = (form) =>
    {
        if(form.password !== form.confirmPassword)
            this.props.dispatch({type: SHOW_MSG, payload: {message: languages[this.props.language].dontMatch,type:'error'}});
        else
            this.props.generateP12(form,this.redirectAfter);
    };

    redirectAfter=()=>
    {
        if(this.props.logged)
            this.props.push(MAIN_ROUTE);
        else
            this.props.push('/');
    };

    renderForm=()=>
    {
        return (
            <div>
            <TitleAndInfo info={languages[this.props.language].generateP12msg}/>
            <Form onSubmit={this.props.handleSubmit(this.generateP12)}>
                <Field name="referenceNumber"
                       prefix={<NumberOutlined className={'icon-font'} />}
                       component={CreateTextField}
                       size={'large'}
                       style={{marginBottom: '5px'}}
                       placeholder={languages[this.props.language].referenceNumber}
                       validate={this.props.language === 'es' ? [required] : [requireden]}
                       hasFeedback/>
                <Field name="authCode"
                       prefix={<NumberOutlined className={'icon-font'} />}
                       component={CreateTextField}
                       size={'large'}
                       style={{marginBottom: '5px'}}
                       placeholder={languages[this.props.language].authCode}
                       validate={this.props.language === 'es' ? [required] : [requireden]}
                       hasFeedback/>
                <Field name="password"
                       prefix={<LockOutlined className={'icon-font'} />}
                       component={CreatePasswordField}
                       autocomplete={'new-password'}
                       size={'large'}
                       style={{marginBottom: '5px'}}
                       visibilityToggle={'false'}
                       placeholder={languages[this.props.language].password}
                       validate={this.props.language === 'es' ? [required] : [requireden]}
                       hasFeedback/>
                <Field name="confirmPassword"
                       prefix={<LockOutlined className={'icon-font'} />}
                       component={CreatePasswordField}
                       size={'large'}
                       autocomplete={'new-password'}
                       style={{marginBottom: '5px'}}
                       visibilityToggle={'false'}
                       placeholder={languages[this.props.language].confirmPassword}
                       validate={this.props.language === 'es' ? [required] : [requireden]}
                       hasFeedback/>
                <Form.Item className={'text-center mb-10'}>
                    <Button type="primary" htmlType="submit" className={'light-blue rounded'}>
                        {languages[this.props.language].generateCertP12}
                    </Button>
                </Form.Item>
                {this.props.logged?'':<Form.Item className={'text-center'}>
                    <Button onClick={()=>this.props.push('/')} type="primary" className={'light-blue rounded'}>
                        {languages[this.props.language].goBack}
                    </Button>
                </Form.Item>}
            </Form>
            </div>
        );
    };

    render() {
        if(this.props.logged)
            return this.renderForm();
        return <PublicLayout isRA={this.props.isRA} title={'logo'}>
            {this.renderForm()}
        </PublicLayout>;
    }
}

const mapStateToProps = state => {
    return {
        language: state.auth.language,
        logged: state.auth.logged,
        isRA:state.auth.isRA
    };
};

export default connect(mapStateToProps, {login, push,generateP12})((reduxForm({form: 'p12_form'})(GenerateCertP12)));
